import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { texts } from 'utils/languages/fr';
import { questionType } from 'utils/constants';
import { Box, Typography } from '@mui/material';

const getQuestionsMinScoring = questions =>
    questions.reduce((acc, crt) => {
        if (!crt?.answers?.length || !crt?.mandatory) return acc + 0;
        if (crt.type === questionType.TEXT) {
            return acc + crt.answers[0].score;
        } else {
            return acc + Math.min(...crt.answers.map(a => a.score));
        }
    }, 0);

const getQuestionsMaxScoring = questions =>
    questions.reduce((acc, crt) => {
        if (!crt?.answers?.length) return acc + 0;
        if (crt.type === questionType.TEXT) {
            return acc + crt.answers[0].score;
        } else if (crt.type === questionType.CHECKBOX) {
            return acc + crt.answers.reduce((a, c) => a + c.score, 0);
        } else {
            return acc + Math.max(...crt.answers.map(a => a.score));
        }
    }, 0);

const ScoringLimits = ({ questions }) => {
    const minScoring = useMemo(() => getQuestionsMinScoring(questions), [questions]);
    const maxScoring = useMemo(() => getQuestionsMaxScoring(questions), [questions]);
    return (
        <Box display="flex" justifyContent="flex-end" gap={1} padding={2}>
            <Typography>
                {texts.MIN_SCORE} : {minScoring}
            </Typography>
            <Typography>
                {texts.MAX_SCORE} : {maxScoring}
            </Typography>
        </Box>
    );
};

ScoringLimits.propTypes = {
    questions: PropTypes.array,
};

export default ScoringLimits;
